/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsownexplanation3Inputs */

const en_listingbuttonsownexplanation3 = /** @type {(inputs: Listingbuttonsownexplanation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick up to four buttons and use the arrows to put them in your order.`)
};

const de_listingbuttonsownexplanation3 = /** @type {(inputs: Listingbuttonsownexplanation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hak bis zu vier Knöpfe an und bring sie mit den Pfeilen in deine Reihenfolge.`)
};

/**
* | output |
* | --- |
* | "Tick up to four buttons and use the arrows to put them in your order." |
*
* @param {Listingbuttonsownexplanation3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsownexplanation3 = /** @type {((inputs?: Listingbuttonsownexplanation3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsownexplanation3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsownexplanation3(inputs)
	return de_listingbuttonsownexplanation3(inputs)
});
export { listingbuttonsownexplanation3 as "listingButtonsOwnExplanation" }